import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import classes from "./SigfoxModalForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addCamectAPI, addSigfoxAPI, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';

const SigfoxIDReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}


const SigfoxModalForm = ({ setShowVirtualSource, inputs, virtualType, fetchVirtualSources, setShowSuccess }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);


    const apiData = {
        token,
        client
    }

    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);

    const [pinSelected, setPinSelected] = useState(null)

    //------------------------------- Modal Logic  ----------------------------------------------

    const ModalDialog = useRef();

    // call ref to clearStates method from child component ScheduledAction.
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        HandelResetModal();
    }
    //-------------------------------------------------------------------------------------------------

    // reset model when Escape key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Handle the Escape key press here
                HandelResetModal();
            }
        };

        // Add event listener when component mounts
        document.addEventListener('keydown', handleKeyDown);


        // Clean up event listener when component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const [formIsValid, setFormIsValid] = useState(false);

    const [sigFoxIDState, dispatchSigFoxIDState] = useReducer(SigfoxIDReducer, {
        value: '',
        isValid: null
    });

    const sigfoxIDInputRef = useRef();

    const { isValid: sigfoxIDIsValid } = sigFoxIDState;

    useEffect(() => {
        const identifier = setTimeout(() => {
            setFormIsValid(sigfoxIDIsValid)
        }, 500);

        return () => {
            clearTimeout(identifier);
        };
    }, [sigfoxIDIsValid]);

    const sigfoxIDChangeHandler = (event) => {
        dispatchSigFoxIDState({ type: 'USER_INPUT', val: event.target.value });
    }

    const validateSigfoxIDHandler = () => {
        dispatchSigFoxIDState({ type: 'INPUT_BLUR' });
    }


    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const onClearHandler = () => {
        dispatchSigFoxIDState({ type: 'INPUT_CLEAR', val: "" })
    }

    const dispatch = useDispatch();

    const submitHandler = async (event) => {
        event.preventDefault();

        const sensorDetails = {
            "device": sigFoxIDState.value,
            "pac": "",
            "uuid": DeviceUUID,
            "virtualInput": pinSelected.toString(),
            "virtualType": virtualType,
        }
        const responseData = await addSigfoxAPI(apiData, sensorDetails, dispatch)
        if (responseData && responseData.success) {
            HandleCloseModal();
            fetchVirtualSources();
            setShowSuccess(true);
        }
    };


    const HandlePinSelected = (pin) => {
        setPinSelected(pin);
        setModalPageIndex(1);
    }

    useEffect(() => {
        switch (modalPageIndex) {
            case 0:
                setModalComponent(
                    <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
                        <h3 style={{color:"#6e6e6e"}}>Which switch would you like to link the sensor to?</h3>
                        <br></br>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>
                            
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                    {inputs.map((input) => {
                                            return (
                                                <li key={input.Pin}>
                                                    <Button2 style={{minWidth:"350px", minHeight:"50px"}}type={"button"} onClick={() => HandlePinSelected(input.Pin)}>
                                                        {input.pinName}
                                                    </Button2>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                )

                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
                        <ul className={classes["inputs-list"]}>
                            <li className={classes["input-container"]}>
                                <label className={classes.subTitle}>Enter sensor ID</label>
                                <Input
                                    className={classes.input}
                                    placeholder={"Sensor ID"}
                                    ref={sigfoxIDInputRef}
                                    id="CamectIP"
                                    type={"text"}
                                    isValid={sigFoxIDState.isValid}
                                    value={sigFoxIDState.value}
                                    onChange={sigfoxIDChangeHandler}
                                    onBlur={validateSigfoxIDHandler}
                                />

                            </li>
                        </ul>
                        <br/>
                        <Button  icon="pi pi-save" type="submit" label="Save" severity='success'/>
                        
                    </form>
                )
                HandleShowModal();
                break;
        }
    }, [modalPageIndex, sigFoxIDState]);

    return (
        <>
            <Modal ref={ModalDialog} title={"Add sensor"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>
        </>
    )
}

export default SigfoxModalForm;